<template>
  <div>
    <v-progress-linear :active="open" indeterminate></v-progress-linear>
    <div>
      <v-divider></v-divider>
      <v-card>
        <div class="pa-2 mt-2">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9"></v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('searchLabelBetonline')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          class="elevation-1 historic-bet"
        >
          <!-- Remove o Items para search -->
          <template v-slot:item.search="{ item }" class="d-none"> </template>
          <!-- Constroi os itesm de eventos -->
          <template v-slot:item.events="{ item }">
            <template v-if="!$vuetify.breakpoint.smAndDown">
              <div class="py-2">
                <div
                  v-for="(event, index) in item.events"
                  :key="index"
                  class="caption"
                >
                  {{ event.description }} (
                  {{ $infoTable.markets(event.id_market).name_market || "" }}
                  -
                  {{ $infoTable.outcomes(event.id_outcome).name_outcome || "" }}
                  - {{ event.factor_event }}) &nbsp;
                  <span
                    class="font-weight-black"
                    v-html="
                      $infoTable.conference(
                        event.result_event,
                        event.status_event
                      )
                    "
                  ></span>

                  <v-chip
                    class="ml-2 font-weight-black"
                    small
                    color="primary"
                    v-if="event.live_event == '1'"
                  >
                    {{ $t("chipIsLive") }}
                  </v-chip>
                </div>
              </div>
            </template>
            <template v-else>
              {{ item.events.length }}
            </template>
          </template>

          <template v-slot:item.date="{ item }">
            <span class="caption">{{ item.date }}</span>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-row>
              <v-col>
                <v-chip
                  class="font-weight-black mr-1"
                  x-small
                  color="blue"
                  v-if="item.debita_saldo == '3'"
                >
                  {{ $t("chipIsBonus") }}
                </v-chip>

                <span class="caption">{{ item.amount }}</span>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.paid="{ item }">
            <v-icon :color="item.paid == 0 ? 'red' : 'green'">{{
              item.paid | formatPaid
            }}</v-icon>
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-btn
                small
                title="Vizualizar"
                @click="showBetDialogOnline(item)"
              >
                <v-icon size="24">mdi-magnify-plus-outline</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>

          <template v-slot:item.result_bet="{ item }">
            <div
              class="font-weight-black"
              v-html="$infoTable.conference(item.result_bet, item.status_bet)"
            ></div>
          </template>
        </v-data-table>
      </v-card>
      <!-- Resume Perído -->
      <div class="mt-4" v-if="resume.amountTotal">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">{{ $t("periodSummaryTitle") }}</div>
              <v-simple-table>
                <template>
                  <tbody>
                    <tr>
                      <td>{{ $t("periodSummaryValue") }}</td>
                      <td class="text-right grey--text darken-4">
                        {{ resume.amountTotal }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("periodSummaryPrizesPaid") }}</td>
                      <td class="text-right green--text darken-4">
                        {{ resume.prizePaid || "0.00" }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("periodSummaryPossibleAwards") }}</td>
                      <td class="text-right orange--text darken-4">
                        {{ resume.prizeNoPaid || "0.00" }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("periodSummaryTotalPrizes") }}</td>
                      <td class="text-right grey--text darken-4">
                        {{ resume.prizeTotal || "0.00" }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- Dialog da aposta -->
    <DialogBetOnline />
  </div>
</template>

<script>
import DialogBetOnline from "../../_components/dialog-bet-online/dialog-bet-online.vue";

export default {
  name: "list-bet",
  components: {
    DialogBetOnline,
  },
  data: () => ({
    search: "",
    data: [],
    open: false,
    resume: {
      amountTotal: "",
      prizePaid: "",
      prizeNoPaid: "",
      prizeTotal: "",
    },
  }),

  computed: {
    // Recuperando o Range armazenado no Store.
    rangeDate() {
      // console.log("Computed: rangeDate");
      return this.$store.state.rangeGlobal.date;
    },
    selectStatusBet() {
      return this.$store.state.filters.selectStatusBetOnline.status;
    },
    eventNumber() {
      return this.$store.state.filters.eventNumber.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    feedBack() {
      return this.$store.state.feedbackProgress;
    },
    headers() {
      return [
        // Coluna "Oculta" com string com informações
        // para serem encontradas na busca.
        { text: "", value: "search", align: " d-none" },
        // Exibidos
        { text: this.$t("listBetOnlineHeaderId"), value: "id" },
        { text: this.$t("listBetOnlineHeaderDateHour"), value: "date" },
        // { text: "Jogador", value: "name_user" },
        { text: this.$t("listBetOnlineHeaderEvents"), value: "events" },
        {
          text: this.$t("listBetOnlineHeaderAmount"),
          value: "amount",
          align: "center",
        },
        { text: this.$t("listBetOnlineHeaderPrize"), value: "prize" },
        { text: this.$t("listBetOnlineHeaderResultBet"), value: "result_bet" },
        { text: this.$t("listBetOnlineHeaderPaid"), value: "paid" },
        { text: this.$t("listBetOnlineHeaderAction"), value: "action" },
      ];
    },
  },

  async mounted() {
    try {
      this.rangeValid = await this.rangeGlobalDate;
    } catch (error) {
      // console.log(error);
    }
    this.listData();
  },

  watch: {
    saveFilters(val) {
      if (!val) return;
      this.listData();
    },
  },
  methods: {
    listData() {
      this.open = true;
      this.reset();
      this.$axios
        .post(
          "/player/bets/list",
          this.$formdata({
            ...this.rangeDate,
            premios: this.selectStatusBet,
            tipo: this.eventNumber,
          })
        )
        .then((resp) => {
          this.data = resp.data.dados.apostas;
          //Build Resume
          this.data.forEach((item) => {
            item.date = new Date(item.date.replace(" ", "T")).toLocaleString();

            // Event Search to Search Events
            item.search = item.events.map((search) => {
              search = `${search.description} ${search.tournaments_name}
               ${this.$infoTable.markets(search.id_market).name_market}
                ${this.$infoTable.outcomes(search.id_outcome).name_outcome}
              ${this.$infoTable.results(item.result_bet)}`;
              return search;
            });
            this.resume = this.$resume.resumeBet(resp.data.dados.apostas);
          });
        })
        .catch((error) => {
          const msg = error.response.data.messages[0];
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.open = false));
    },

    putInfosForFilter: function(arrBets) {
      arrBets.forEach((item) => {
        // Put Size
        item.events.length >= 4
          ? this.$set(item, "size", 4)
          : this.$set(item, "size", item.events.length);

        // Puts conference
        if (item.status_bet == 0) {
          this.$set(item, "conference", "cancelado");
        } else {
          if (item.result_bet == 1) {
            this.$set(item, "conference", "acertou");
          } else if (item.result_bet == 0 && item.result_bet != "") {
            this.$set(item, "conference", "errou");
          } else {
            this.$set(item, "conference", "pendente");
          }
        }
      });

      return arrBets;
    },

    showBetDialogOnline(item) {
      this.$store.commit("showBetDialog", {
        status: true,
        value: item,
      });
    },
    reset() {
      this.data = [];
      this.resume = {};
    },
  },
  filters: {
    formatPaid(val) {
      const format = val == 1 ? "mdi-check" : "mdi-close";
      return format;
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  max-height: 56px !important;
  min-height: 32px !important;
  border-bottom: 1px dashed #000;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1),
.v-data-table-header-mobile {
  display: none;
}
.historic-bet.v-data-table
  > .v-data-table__wrapper
  td.v-data-table__mobile-row:last-child {
  height: 56px !important;
  border-bottom: 6px solid #000 !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(2) {
  height: 56px !important;
  font-size: 18px;
  border-bottom: 0px !important;
}
</style>
